import Vue from 'vue'
import VueShepherd from 'vue-shepherd'
import 'shepherd.js/dist/css/shepherd.css'

Vue.use(VueShepherd)
